import { AppRouteNames } from "@/shared/@types/AppRouteNames";

export const getDefaultHomeUserRoute = (
  isEquivoltKpiDashboardsEnabled: boolean,
) =>
  isEquivoltKpiDashboardsEnabled
    ? AppRouteNames.FleetAtHomeDashboard
    : AppRouteNames.FleetAtHomeStations;

export const getDefaultHomeManagerRoute = (
  isEquivoltKpiDashboardsEnabled: boolean,
) =>
  isEquivoltKpiDashboardsEnabled
    ? AppRouteNames.FleetAtHomeManagementDashboard
    : AppRouteNames.FleetAtHomeManagementUsers;

export const getDefaultHomePreSalesManagerRoute = () =>
  AppRouteNames.FleetAtHomeManagementTcoCalculator;
